<template>
  <section class="how-it-works-section">
    <!-- Section Header -->
    <div class="how-it-works-header">
      <h3 class="how-it-works-title">
        How Can I <i>Gift Crypto</i>?
      </h3>
      <p class="how-it-works-subtitle">
        Some gifts take days to arrive. Yours will take seconds. Send and redeem a crypto card in a few clicks
      </p>
    </div>

    <!-- Steps List -->
    <div class="steps-list">
      <div
        v-for="step in steps"
        :key="step.number"
        class="step-card"
      >
        <!-- Step Number Circle -->
        <div class="step-number">
          <span class="step-number-text">{{ step.number }}</span>
        </div>

        <!-- Step Content -->
        <div class="step-content">
          <h5 class="step-title">
            {{ step.title }}
          </h5>
          <p class="step-description">
            {{ step.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const steps = [
  {
    number: 1,
    title: 'Customize',
    description: 'Choose your crypto, enter the amount and add a personal message'
  },
  {
    number: 2,
    title: 'Top up',
    description: 'Pay via card or crypto and receive a unique link with emoji PIN'
  },
  {
    number: 3,
    title: 'Share',
    description: 'Send the gift link and emoji PIN code to your recipient'
  },
  {
    number: 4,
    title: 'Redeem',
    description: 'They enter PIN, drop their wallet and receive funds instantly'
  }
]
</script>

<style scoped>
.how-it-works-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 16px;
  gap: 24px;
  background: #4B71EE;
  border-radius: 24px;
  max-width: 100%;
  overflow: hidden;
}

.how-it-works-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  align-self: stretch;
}

.how-it-works-title {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
}

.how-it-works-subtitle {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  align-self: stretch;
}

.steps-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  align-self: stretch;
}

@media (max-width: 768px) {
  .steps-list {
    grid-template-columns: 1fr;
  }
}

.step-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 24px;
  background: #FFFFFF;
  border-radius: 12px;
  align-self: stretch;
}

.step-number {
  position: relative;
  width: 32px;
  height: 32px;
  background: #EBEFFD;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-number-text {
  font-family: 'Inter Tight', sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #4B71EE;
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  align-self: stretch;
}

.step-title {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: #182855;
  align-self: stretch;
}

.step-description {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.005em;
  color: #3A55A6;
  align-self: stretch;
}
</style>
